import type { FC, PropsWithChildren } from 'react';
import styles from './modal.module.css';

export const ModalFooter: FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.footer}>{children}</div>;
};
